import { Sortable as i } from "@shopify/draggable";
import d from "./plugins/place-animation.js";
/* empty css              */
const c = {
  containers: "[pendo-draggable-container]",
  item: "[pendo-draggable-item]",
  handle: "[pendo-draggable-handle]",
  mirror: {
    constrainDimensions: !0
  },
  placeAnimation: {
    easingFunction: "ease-in-out"
  },
  classes: {
    mirror: "pendo-draggable-mirror",
    "body:dragging": "pendo-draggable--is-dragging",
    "draggable:over": "pendo-draggable--over",
    "container:dragging": "pendo-draggable-container--is-dragging",
    "container:over": "pendo-draggable-container--over",
    "container:placed": "pendo-draggable-container--placed",
    "source:dragging": "pendo-draggable-source--is-dragging",
    "source:original": "pendo-draggable--original",
    "source:placed": "pendo-draggable-source--placed"
  }
};
function u(a, e) {
  return {
    classes: {
      ...o.options.classes,
      ...e.classes
    },
    draggable: e.item || o.options.item,
    // we only add the handle if it's either
    // 1. passed in by consumer
    // 2. we find at least 1 child with pendo-draggable-handle attribute
    ...e.handle && {
      handle: e.handle
    },
    ...a.querySelectorAll(o.options.handle).length && {
      handle: o.options.handle
    },
    containers: o.options.containers || e.containers,
    mirror: {
      ...o.options.mirror,
      ...e.mirror
    },
    ...e.plugins && { plugins: e.plugins },
    disabled: e.disabled
  };
}
function l(a, e) {
  const n = !!a.querySelectorAll("[pendo-draggable-container]").length, r = !!a.querySelectorAll("[pendo-draggable-item]").length, t = !!a.querySelectorAll("[pendo-draggable-handle]").length;
  return e.containers.length === 1 ? e.options.handle ? r && t : r : e.options.handle ? n && r && t : n && r;
}
function b(a) {
  let e = a, n = !1;
  for (; e; )
    e.hasAttribute("pendo-draggable-ignore") ? (n = !0, e = void 0) : e = e.parentElement;
  return n;
}
function p(a, { events: e } = {}) {
  e && Object.keys(e) && Object.entries(e).forEach(([n, r]) => {
    a.on(n, r);
  });
}
function h(a, { value: e }) {
  const n = {
    ...u(a, {
      ...e
    }),
    plugins: [d]
  };
  let r = a.querySelectorAll(n.containers);
  r.length === 0 && (r = a);
  const t = !!a.querySelectorAll("[pendo-draggable-ignore]").length;
  return new i(r, { ...n, hasIgnoredSelectors: t });
}
function f(a, e) {
  if (e.value === !1)
    return;
  const n = h(a, e);
  a.classList.add("pendo-draggable"), n.options.handle ? a.classList.add("has-draggable-handles") : a.classList.add("has-draggable-items"), a.classList.toggle("is-draggable", l(a, n)), p(n, e.value), n.on("drag:start", (t) => {
    const g = l(a, n);
    if (n.disabled || !g) {
      t.cancel();
      return;
    }
    if (!!!a.querySelectorAll("[pendo-draggable-ignore]").length)
      return;
    const { target: s } = t.originalEvent;
    b(s) && t.cancel();
  });
  const r = e.instance;
  r.PendoDraggable || (r.PendoDraggable = n);
}
function m(a, e) {
  if (e.value === !1)
    return;
  const { PendoDraggable: n } = e.instance;
  a.classList.toggle("is-draggable", l(a, n));
}
function A(a, e) {
  e.instance.PendoDraggable && (e.instance.PendoDraggable.destroy(), delete e.instance.PendoDraggable);
}
const o = {
  options: c,
  mounted: f,
  updated: m,
  unmounted: A
};
export {
  c as DRAGGABLE_DEFAULTS,
  o as PendoDraggable,
  h as createDraggable,
  o as default,
  l as getDraggableStatus,
  u as getOptions,
  f as mounted,
  p as registerEventListeners,
  b as shouldCancelDrag,
  A as unmounted,
  m as updated
};
//# sourceMappingURL=pendo-draggable.js.map
